// extracted by css-extract-rspack-plugin
export default {"layout":"cKgEt","header":"sOZNo","main":"DCXmy","sidebar":"RUOKD","footer":"RQrX6"};